import * as React from "react"
const IconDuracion = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 60 60"
        width={width}
        height={height}
    >
        <path
            d="M0 0h60v60H0z"
            style={{
                fill: "#eae0d8",
            }}
        />
        <path
            d="M1.97 1.81h56.32v56.32H1.97z"
            style={{
                fill: "none",
                stroke: "#354060",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="m31.45 8.34 2.57.36c18 3.47 23.43 27.06 8.29 37.87-12.58 8.98-30.06 1.78-32.96-13.19l-.36-2.57c.04-.93-.05-1.88 0-2.8.61-10.35 9.32-19.07 19.67-19.67h2.8Zm-1.58 1.83c-15.52.16-24.5 17.8-15.44 30.46 8.62 12.05 27.26 10.1 33.21-3.45 5.61-12.77-3.86-27.15-17.78-27.01Z"
            style={{
                fill: "#354060",
            }}
        />
        <path
            d="M29.87 19.8c.49-.09.93.22 1.09.69l.05 8.6 9.75 9.76c.75.93-.42 2.04-1.32 1.24L29.2 29.75l-.05-9.18c.04-.35.39-.7.72-.76ZM30.69 13.14c.57.51.38 2.2-.72 2.08-.85-.09-.98-1.07-.75-1.75.18-.56 1.06-.7 1.47-.33ZM13.79 30.04c-.37-.42-.23-1.29.33-1.47.68-.22 1.66-.1 1.75.75.12 1.1-1.57 1.29-2.08.72ZM46.32 28.78c.37.42.23 1.29-.33 1.47-.68.22-1.66.1-1.75-.75-.12-1.1 1.57-1.29 2.08-.72ZM30.69 45.68c-.42.37-1.29.23-1.47-.33-.22-.68-.1-1.66.75-1.75 1.1-.12 1.29 1.57.72 2.08ZM19.01 17.49c.73-.07 1.78 1.19 1 1.91-.97.91-2.63-1.01-1.42-1.75.1-.06.31-.15.42-.16ZM40.97 17.49c.21-.02.53.12.68.27 1.13 1.05-1.32 2.86-1.81 1.23-.18-.61.56-1.44 1.13-1.5ZM19.4 39.16c.72 0 1.13.82.74 1.44-.32.51-.97.92-1.55.57-1-.61-.02-2.01.81-2Z"
            style={{
                fill: "#354060",
            }}
        />
    </svg>
)
export default IconDuracion
